import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { EmptyTicket } from "./EmptyTicket";
import { Form } from "./Form";
import { Table } from "./Table";
import { ITicketMast } from "../../models/TicketMast";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: ITicketMast
}

export const TicketMast = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyTicket, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyTicket, open: false })
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table setModal={setModal} toast={toast} reload={reload} setReload={setReload} permissions={permissions}></Table>
            <Toast ref={toast} />
        </>
    );
}
